import { Component, OnInit } from '@angular/core';
import { IntegrationService } from '../integration.service';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { ChartType } from 'chart.js';
import { MultiDataSet, Label } from 'ng2-charts';

@Component({
  selector: 'app-breakdown',
  templateUrl: './breakdown.component.html',
  styleUrls: ['./breakdown.component.css']
})
export class BreakdownComponent implements OnInit {
  public userId;
  public mostExpensive;
  public upcomingRenewal;
  public monthlySpending;
  public categorialBreakdown;
  public doughnutChartLabels ;
  public doughnutChartData ;
  public doughnutChartType;
  public showChart = false;
  public loading;
  subscriptionPlan;

  constructor(private http:HttpClient,private _integrationService:IntegrationService,private router:Router) {
    this._integrationService.subscriptionPlan$.subscribe((data)=>{this.subscriptionPlan=data})
   }


   getBreakdown(userId){
    let breakdownEndpoint = `https://subscrybe-backend.herokuapp.com/get-breakdown/${userId}`
    this.http.get(breakdownEndpoint).subscribe(data=>{
      this.mostExpensive = data['most_expensive'] //subscription
      this.upcomingRenewal = data['upcoming_renewal'] //subscription
      this.monthlySpending = data['monthly_spending']
      this.categorialBreakdown = data['categorial_breakdown']
      this.doughnutChartLabels = Object.keys(this.categorialBreakdown);
      this.doughnutChartData  = Object.values(this.categorialBreakdown);
      this.doughnutChartType  = 'pie';
      this.loading = false;
      this.showChart = true;
      // console.log(this.doughnutChartData)
    })
   }

   getDashboard(){
     this.router.navigate(['/dashboard'])
   }

   getColor(url){
    return {'background': `url(https://logo.clearbit.com/${url.replace('netflix','netflixinvestor')})`,'background-repeat':'no-repeat','height':'175px','background-position':'center'}
    
  }

  formattedDate(date){
    return new Date(date).toDateString();
  }

  getImage(url=''){
    let newUrl = url.replace('https://','').replace('www.','')
    if(newUrl.includes('indeed')){
      return 'https://logo.clearbit.com/www.indeed.com'
    }
    if(newUrl.includes('hulu')){
      return 'https://logo.clearbit.com/hulu.jp'
    }
    console.log(`https://logo.clearbit.com/${newUrl.split('/')[0]}`)
    return `https://logo.clearbit.com/${newUrl.split('/')[0]}`
  }

  chartOptions = {
    responsive: true
  };

  chartData = [
    { data: [330, 600, 260, 700], label: 'Account A' },
    { data: [120, 455, 100, 340], label: 'Account B' },
    { data: [45, 67, 800, 500], label: 'Account C' }
  ];

  chartLabels = ['January', 'February', 'Mars', 'April'];

  onChartClick(event) {
    console.log(event);
  }

  changeChart(chart){
    this.doughnutChartType = chart;
  }

  getChart(chart){
    return this.doughnutChartType == chart ? 'selectedChart' : 'unselectedChart'
  }


  ngOnInit() {
    this.loading = true;
    this._integrationService.getUser();
    this._integrationService.userId$.subscribe((data)=>{console.log(data);this.getBreakdown(data.replace(/"/g,""))})
  }

}
